'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _clear = require('unmutable/lib/clear');

var _clear2 = _interopRequireDefault(_clear);

var _delete = require('unmutable/lib/delete');

var _delete2 = _interopRequireDefault(_delete);

var _get = require('unmutable/lib/get');

var _get2 = _interopRequireDefault(_get);

var _reduce = require('unmutable/lib/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _set = require('unmutable/lib/set');

var _set2 = _interopRequireDefault(_set);

var _shallowToJS = require('unmutable/lib/shallowToJS');

var _shallowToJS2 = _interopRequireDefault(_shallowToJS);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _isValueObject = require('unmutable/lib/util/isValueObject');

var _isValueObject2 = _interopRequireDefault(_isValueObject);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return function (parcelData) {
        var value = parcelData.value,
            child = parcelData.child;

        var addMeta = (0, _update2.default)('meta', function (meta) {
            return meta || {};
        });

        if (!(0, _isValueObject2.default)(value)) {
            return (0, _pipeWith2.default)(parcelData, (0, _delete2.default)('child'), addMeta);
        }

        return (0, _pipeWith2.default)(parcelData, (0, _set2.default)('child', (0, _pipeWith2.default)(value, (0, _reduce2.default)(function (red, value, key) {
            return (0, _pipeWith2.default)(red, (0, _set2.default)(key, child ? (0, _get2.default)(key, {})(child) : {}));
        }, (0, _pipeWith2.default)(value, (0, _shallowToJS2.default)(), (0, _clear2.default)())))), addMeta);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/updateChild.js
// module id = 241
// module chunks = 35783957827783